(function () {
  function publishEvent(name, payload) {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(name, payload);
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: name,
      product_landing: payload
    });
  }

  function getLandingPayload(element) {
    return {
      landing_slug: element.dataset.landingSlug || '',
      product_id: element.dataset.productId || '',
      variant_id: element.dataset.variantId || ''
    };
  }

  function setupAnalytics() {
    var root = document.querySelector('[data-product-landing]');
    if (!root) return;

    publishEvent('landing_viewed', getLandingPayload(root));

    document.querySelectorAll('[data-landing-cta]').forEach(function (button) {
      button.addEventListener('click', function () {
        publishEvent('landing_cta_clicked', getLandingPayload(button));
      });
    });
  }

  function setupReviewLightbox() {
    var lightbox = document.querySelector('[data-review-lightbox]');
    if (!lightbox) return;

    var lightboxImage = lightbox.querySelector('[data-review-lightbox-image]');
    var closeButton = lightbox.querySelector('[data-review-lightbox-close]');
    var root = document.querySelector('[data-product-landing]');

    function closeLightbox() {
      lightbox.hidden = true;
      lightboxImage.removeAttribute('src');
      lightboxImage.removeAttribute('alt');
      document.documentElement.classList.remove('product-landing-lightbox-open');
    }

    document.querySelectorAll('[data-review-image]').forEach(function (button) {
      button.addEventListener('click', function () {
        lightboxImage.src = button.dataset.imageSrc;
        lightboxImage.alt = button.dataset.imageAlt || '';
        lightbox.hidden = false;
        document.documentElement.classList.add('product-landing-lightbox-open');

        if (root) {
          publishEvent('landing_review_image_opened', getLandingPayload(root));
        }
      });
    });

    closeButton.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !lightbox.hidden) closeLightbox();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupAnalytics();
    setupReviewLightbox();
  });
})();
